/**
 * Validates that a template ID is safe to use in URLs.
 * Rejects IDs that could be used for path traversal attacks.
 *
 * Valid template IDs should only contain alphanumeric characters, hyphens, and underscores.
 * This provides defense-in-depth - the server should also validate, but client-side
 * validation prevents potentially malicious input from being sent.
 *
 * @param templateId - The template ID to validate
 * @returns true if the template ID is valid, false otherwise
 */
export function isValidTemplateId(templateId: string): boolean {
	// Reject empty strings
	if (!templateId || templateId.length === 0) {
		return false;
	}

	// Reject path traversal attempts
	if (templateId.includes("..") || templateId.includes("/") || templateId.includes("\\")) {
		return false;
	}

	// Only allow alphanumeric characters, hyphens, and underscores
	// This matches typical document/template ID formats
	const validPattern = /^[a-zA-Z0-9_-]+$/;
	return validPattern.test(templateId);
}
